// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__ECW5z","content":"Consent_content__3sXxt","footer":"Consent_footer__2mqss"};